import { API_URL } from "../../constants/config";
import createAxiosInstance from "../../utils/axiosInstance";

export const getEnrolledEvents = async (accessToken, params, postParams) => {
  let url = '/enrolled-events'
  const queryParams = [];

  for (const [key, value] of Object.entries(params)) {
    if (value) {
      queryParams.push(`${key}=${value}`);
    }
  }

  if (queryParams.length > 0) {
    url += `?${queryParams.join('&')}`;
  }

  try {
    const axiosInstance = createAxiosInstance(accessToken);
    const response      = await axiosInstance.post(url, postParams);
    return response.data;
  } catch(err) {
    console.log(err);
  }
}

export const getEventContents = async (accessToken, params) => {
  let url = `enrolled-events/${params.slug}`

  try {
    const axiosInstance = createAxiosInstance(accessToken);
    const response      = await axiosInstance.get(url);
    return response.data;
  } catch(err) {
    console.log(err);
  }
}

export const eventTransfer = async (accessToken, params) => {
  const url = `${API_URL}api/v1/`;

  try {
    const axiosInstance = createAxiosInstance(accessToken, url);
    const response      = await axiosInstance.post('event_transfer', params);
    return response.data;
  } catch(err) {
    console.log(err);
  }
}

export const eventTransferOrder = async (accessToken, params) => {
  const url = `${API_URL}api/v1/`;

  try {
    const axiosInstance = createAxiosInstance(accessToken, url);
    const response      = await axiosInstance.post('transfer_order', params);
    return response.data;
  } catch(err) {
    console.log(err);
  }
}

export const selfCancellationEvent = async (accessToken, params) => {
  const url = `${API_URL}api/v1/`;

  try {
    const axiosInstance = createAxiosInstance(accessToken, url);
    const response      = await axiosInstance.post('self_cancellation', params);
    return response.data;
  } catch(err) {
    console.log(err);
  }
}

export const confirmCancellationEvent = async (accessToken, params) => {
  const url = `${API_URL}api/v1/`;

  try {
    const axiosInstance = createAxiosInstance(accessToken, url);
    const response      = await axiosInstance.post('confirm_cancellation', params);
    return response.data;
  } catch(err) {
    console.log(err);
  }
}


